import { render, staticRenderFns } from "./BananaPage.vue?vue&type=template&id=43a6451e&scoped=true&"
import script from "./BananaPage.vue?vue&type=script&lang=js&"
export * from "./BananaPage.vue?vue&type=script&lang=js&"
import style0 from "./BananaPage.vue?vue&type=style&index=0&id=43a6451e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a6451e",
  null
  
)

export default component.exports